import { createApi } from '@reduxjs/toolkit/query/react';
import { getAllCountries } from '$store/modules/countries/queries';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';

export const countriesApi = createApi({
  reducerPath: ReducerPaths.COUNTRY,
  baseQuery,
  tagTypes: ['country'],
  endpoints: (builder) => ({
    getAllCountries: getAllCountries(builder),
  }),
});

export const { useGetAllCountriesQuery } = countriesApi;
